import React from 'react';
import {
	Form,
	Popover,
	Space,
} from 'antd';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faCrosshairs,
	faCrosshairsSimple,
	faLock,
	faLockOpen,
} from '@fortawesome/pro-light-svg-icons';
import NumericInput from '@client/components/NumericInput';
import Button from '@client/components/Button';
import styles from './styles/EstimatedPnL.module.css';

type TargetControlsProps = {
	name: string;
	label: string;
	isLocked: boolean;
	target: number | null;
	onLock: () => void;
	onSetTarget: (target: number) => void;
	disabled?: boolean;
	inputDisabled?: boolean;
	shortcut?: string;
};

const TargetControls = ({
	name,
	label,
	isLocked,
	target,
	onLock,
	onSetTarget,
	disabled = false,
	inputDisabled = false,
	shortcut,
}: TargetControlsProps) => {
	const isInputDisabled = disabled || inputDisabled || isLocked;

	return (
		<Space size="small">
			<FontAwesomeIcon
				className={classNames(styles.cursor, {
					[styles.locked]: isLocked,
					[styles.disabled]: disabled,
				})}
				onClick={() => {
					if (disabled) {
						return;
					}

					onLock();
				}}
				icon={isLocked ? faLock : faLockOpen}
			/>
			<Popover
				content={(
					<Form
						initialValues={{ [name]: target }}
						onFinish={(values: Record<string, number>) => onSetTarget(values[name])}
						layout="vertical"
					>
						<Form.Item name={name} label={label}>
							<NumericInput disabled={isInputDisabled} />
						</Form.Item>
						<Form.Item>
							<Button
								htmlType="submit"
								type="primary"
								disabled={isInputDisabled}
							>
								{`Set ${label}`}
							</Button>
						</Form.Item>
					</Form>
				)}
				trigger="click"
			>
				<FontAwesomeIcon
					data-shortcut={disabled ? undefined : shortcut}
					color="#1677ff"
					className={classNames(styles.cursor, {
						[styles.disabled]: disabled,
					})}
					icon={target == null ? faCrosshairs : faCrosshairsSimple}
				/>
			</Popover>
		</Space>
	);
};

export default TargetControls;
